import { useEffect, useMemo, useState } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import api from "../lib/api";
import { ButirSheet, BUTIR_CSS, paginateMonths } from "../components/ButirSheets";

export default function JanaLaporanPrint() {
  const { vehicleId } = useParams();
  const [params] = useSearchParams();
  const year = Number(params.get("year")) || new Date().getFullYear();
  const month = params.get("month") ? Number(params.get("month")) : null;
  const [data, setData] = useState(null);
  const [err, setErr] = useState(null);

  useEffect(() => {
    api.get(`/reports/buku-log/${vehicleId}`, { params: { year, ...(month && { month }) } })
      .then((r) => setData(r.data))
      .catch(() => setErr("Gagal memuatkan data laporan."));
  }, [vehicleId, year, month]);

  const pages = useMemo(() => {
    if (!data) return [];
    return paginateMonths(data.months, `${year}-${String(month || 1).padStart(2, "0")}`);
  }, [data, year, month]);

  if (err) return <div style={{ padding: 40, fontFamily: "Arial" }}>{err}</div>;
  if (!data) return <div style={{ padding: 40, fontFamily: "Arial" }}>Menjana laporan...</div>;

  return (
    <div className="butir-doc" style={{ background: "#525659", minHeight: "100vh" }} data-testid="jana-laporan-print-page">
      <style>{BUTIR_CSS}</style>
      <style>{`
        .butir-doc .sheet { margin: 12px auto; }
        .jl-print-btn { position: fixed; top: 14px; right: 18px; z-index: 50; background: #10056E; color: #fff; border: 0; border-radius: 8px; padding: 10px 18px; font-size: 13px; font-weight: 600; cursor: pointer; box-shadow: 0 4px 14px rgba(0,0,0,.35); }
        @page { size: A4 landscape; margin: 0; }
        @media print {
          .butir-doc { background: #fff !important; }
          .jl-print-btn { display: none; }
          .butir-doc .sheet { margin: 0; page-break-after: always; height: 210mm; box-shadow: none; }
        }
      `}</style>
      <button className="jl-print-btn" onClick={() => window.print()} data-testid="jana-laporan-print-btn">
        Cetak / Simpan PDF
      </button>
      {pages.map((p, i) => (
        <ButirSheet key={i} data={data} page={p} footer={`M.S. ${i + 1}/${pages.length}`} />
      ))}
    </div>
  );
}
